import { ReactNode } from "react";

export const GOAL_PLANNING = "GOAL_PLANNING";
export const FINANCIAL_ADVISOR = "FINANCIAL_ADVISOR";
export const TECH = "TECH";
export const ROBO = "ROBO";
export const FEES = "FEES";
export const RESEARCH_TOOLS = "RESEARCH_TOOLS";
export const EDUCATION_MATERIAL = "EDUCATION_MATERIAL";
export const INVESTMENT_OPTIONS = "INVESTMENT_OPTIONS";

export type Feature =
  | typeof GOAL_PLANNING
  | typeof FINANCIAL_ADVISOR
  | typeof TECH
  | typeof ROBO
  | typeof FEES
  | typeof RESEARCH_TOOLS
  | typeof EDUCATION_MATERIAL
  | typeof INVESTMENT_OPTIONS;

// FAMILY_INVESTMENT, FINANCIAL_ADVISOR, TECH, ROBO, FEES, RESEARCH_TOOLS, EDUCATION_MATERIAL, INVESTMENT_OPTIONS;

export const iraItemIds: Feature[] = [INVESTMENT_OPTIONS, RESEARCH_TOOLS, FEES, TECH, FINANCIAL_ADVISOR];

export const roboIRAItemIds: Feature[] = [ROBO, FEES, FINANCIAL_ADVISOR, GOAL_PLANNING, TECH];

export const SIGN_UP_BONUS = "BONUS";
export const FAMILY = "FAMILY_SAVINGS";
export const ESG = "ESG";
export const NONE = "NONE";

export type AdditionalFeature = typeof SIGN_UP_BONUS | typeof FAMILY | typeof ESG | typeof NONE;
export const RARELY_NEED_HELP = "NONE";
export const PERSON = "TALK";
export const DIGITAL = "NO_TALK";
export type HelpPreference = typeof RARELY_NEED_HELP | typeof PERSON | typeof DIGITAL;

export type IRASurveyData = {
  featurePreference?: {
    FIRST: Feature;
    SECOND: Feature;
    THIRD: Feature;
    FOURTH: Feature;
    FIFTH: Feature;
  };
  extras?: AdditionalFeature[];
  supportModel?: HelpPreference;
};

export type ProviderContent = {
  providerName?: string;
  logo?: string;
  descriptionMain?: string;
  description?: string;
  hereIsWhy?: Array<{ icon: ReactNode; text: string }>;
  standoutFeatures?: Array<{ heading: string; description: string }>;
  whoItsBestFor?: Array<{ heading: string; description: string }>;
  otherConsiderations?: Array<{ heading: string; description: string }>;
  additionalBenefits?: Array<{ heading: string; description: string }>;
};

export type IRARecommendationContent = {
  FIRST: ProviderContent;
  SECOND: ProviderContent;
  THIRD: ProviderContent;
  FOURTH: ProviderContent;
};
